import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { ConfigStateType, TabType } from '@redux/types'
import { grey } from '@mui/material/colors'

export const firstMainTap = {
	id: '0',
	name: '',
	path: '/main/home',
	i18n: [],
}

export const firstAdminTap = {
	id: '0',
	name: '',
	path: '/admin/home',
	i18n: [],
}

// initial state
const initialState: ConfigStateType = {
	// system
	systemName: '',
	systemSubtitle: '',

	// menu
	menu: [],
	isAdminDrawerHeadAnimated: true,

	// device
	isMobile: false,

	// mode
	mode: 'main',

	// toast
	toast: {
		isShow: false,
		message: '',
	},

	// screen
	backgroundColor: '#fff',
	mainBackgroundColor: grey[100],
	isLoading: false,

	// tab
	selectedTabIdx: '1',
	tabList: [firstMainTap],

	// drawer
	drawerWidth: 240,
	closedDrawerWidth: 64,
	isOpenDrawer: true,
	isHomeOpenDrawer: false,
	drawerScrollTop: 0,
}

const slice = createSlice({
	name: 'config',
	initialState,
	reducers: {
		// system
		SYSTEM_NAME: (state: ConfigStateType, action: PayloadAction<string>) => {
			state.systemName = action.payload
		},
		SYSTEM_SUBTITLE: (state: ConfigStateType, action: PayloadAction<string>) => {
			state.systemSubtitle = action.payload
		},

		// menu
		MENU: (state: ConfigStateType, action: PayloadAction<ConfigStateType['menu']>) => {
			state.menu = action.payload
		},
		IS_ADMIN_DRAWER_HEAD_ANIMATED: (
			state: ConfigStateType,
			action: PayloadAction<boolean>,
		) => {
			state.isAdminDrawerHeadAnimated = action.payload
		},

		// device
		IS_MOBILE: (state: ConfigStateType, action: PayloadAction<boolean>) => {
			state.isMobile = action.payload
		},

		// mode
		MODE: (state: ConfigStateType, action: PayloadAction<ConfigStateType['mode']>) => {
			state.mode = action.payload
		},

		// toast
		TOAST: (state: ConfigStateType, action: PayloadAction<ConfigStateType['toast']>) => {
			state.toast = action.payload
		},

		// screen
		IS_LOADING: (state: ConfigStateType, action: PayloadAction<boolean>) => {
			state.isLoading = action.payload
		},

		// tab
		SELECTED_TAB_IDX: (state: ConfigStateType, action: PayloadAction<string>) => {
			state.selectedTabIdx = action.payload
		},
		TAB_LIST: (state: ConfigStateType, action: PayloadAction<TabType[]>) => {
			state.tabList = action.payload
		},

		// drawer
		DRAWER_WIDTH: (state: ConfigStateType, action: PayloadAction<number>) => {
			state.drawerWidth = action.payload
		},
		IS_OPEN_DRAWER: (state: ConfigStateType, action: PayloadAction<boolean>) => {
			state.isOpenDrawer = action.payload
		},
		IS_HOME_OPEN_DRAWER: (state: ConfigStateType, action: PayloadAction<boolean>) => {
			state.isHomeOpenDrawer = action.payload
		},
		DRAWER_SCROLL_TOP: (state: ConfigStateType, action: PayloadAction<number>) => {
			state.drawerScrollTop = action.payload
		},
	},
})

export const configActions = slice.actions
export default slice.reducer
